import { axios } from "../config";
  
function getProductDemoRequests(data) {
  return axios.get("api/v1/demo-requests", {params: data});
}
  
function updateProductDemoRequest(id, data) {
  return axios.post(`api/v1/demo-requests/${id}`, data);
}

function getContactQueries(data) {
  return axios.get("api/v1/contact-us", {params: data});
}

export { getProductDemoRequests, updateProductDemoRequest, getContactQueries };
